<div class="gl-table__container">
  <div *ngIf="selectable && isAnySelected">
    <div class="lms-toolbar__secondary" [ngClass]="{ hidden: !isAnySelected }" tools-actions>
      <div class="list-counter">
        <span>
          {{ isHeaderSelectedAll ? dataSource.total - excludedStudents.size : selectedStudents.length }}
          {{ (selectedStudents.length === 1 ? 'students.bulk.selectedSingle' : 'students.bulk.selected') | translate }}
        </span>
        <a
          (click)="setSelectAll(true)"
          *ngIf="!isHeaderSelectedAll && !enrollmentGroup"
          title="{{ 'students.bulk.selectAll' | translate : { total: dataSource.total } }}"
          >{{ 'students.bulk.selectAll' | translate : { total: dataSource.total } }}
        </a>
      </div>
      <div class="actions">
        <ng-container *ngIf="!enrollmentGroup; else enroll">
          <a
            (click)="openModal(jobs.ACTIVATE_USERS_BULK)"
            *lmsProfileGuard="'students.active-bulk'"
            title="{{ 'actions.unblock' | translate }}"
          >
            {{ 'actions.activate' | translate }}
          </a>
          <a
            (click)="openModal(jobs.DEACTIVATE_USERS_BULK)"
            *lmsProfileGuard="'students.block-bulk'"
            title="{{ 'actions.block' | translate }}"
          >
            {{ 'actions.block' | translate }}
          </a>
        </ng-container>
        <ng-template #enroll>
          <a (click)="enrollSelectedStudents()" title="{{ 'actions.enroll' | translate }}" class="margin-half-right">
            {{ 'actions.enroll' | translate }}
          </a>
        </ng-template>
        <ng-container *ngIf="!enrollmentGroup">
          <lms-button-actions
            id="students_list_bulk_actions"
            class="margin-half-right margin-half-left"
            [items]="actionItems"
            (change)="selectAction($event)"
          ></lms-button-actions>
          <lms-edit-tags
            #licenseEditTags
            [count]="isHeaderSelectedAll ? dataSource.total - excludedStudents.size : selectedStudents.length"
            [list]="selectedStudents"
            (addTagsSelected)="addTags($event)"
            (removeTagsSelected)="removeTags($event)"
          >
          </lms-edit-tags>
          <lms-personalized-email
            #personalizedEmail
            [adminData]="user"
            [count]="isHeaderSelectedAll ? dataSource.total - excludedStudents.size : selectedStudents.length"
            (sendEmail)="sendEmail($event)"
          ></lms-personalized-email>
        </ng-container>
        <div class="border-left padding-left margin-left-8">
          <gl-button
            color-secondary
            small
            [text]="'actions.cancelSelection' | translate"
            (onClick)="setSelectAll(false)"
          >
          </gl-button>
        </div>
      </div>
    </div>
  </div>

  <gl-table
    #studentsTable
    [id]="listId"
    [dataSource]="dataSource"
    data-testid="studentsTable"
    [placeholder]="'actions.noResultTable' | translate"
    [attr.disableHeaderSelector]="isHeaderSelectedAll ? true : null"
    [attr.selectable]="selectable ? true : null"
    paginator
    scroll
    (onClickRow)="onClickRow($event.detail.data)"
    (onSelectionChanged)="onSelectionChanged($event.detail)"
    (onRowSelectionChanged)="onRowSelectionChanged($event.detail)"
    (onFiltersChanged)="onFiltersChanged()"
    (onDatasourceUpdate)="onDatasourceUpdate()"
  >
  </gl-table>
</div>

<lms-modal #activateModal size="small">
  <div class="gl-popup__title">{{ 'students.bulk.' + action.toLowerCase() + 'Title' | translate }}</div>
  <div class="gl-popup__close" (click)="activateModal.close()">
    <span class="glicon-close"></span>
  </div>
  <div
    class="gl-popup__text"
    [innerHtml]="
      'students.bulk.' + action.toLowerCase() + (selectedStudents.length > 1 ? 'Text' : 'TextSingle')
        | translate
          : { total: isHeaderSelectedAll ? dataSource.total - excludedStudents.size : selectedStudents.length }
    "
  ></div>
  <div
    *ngIf="actionProps[action] && actionProps[action].unreverseMessage"
    class="gl-popup__text alert"
    [innerHtml]="'students.bulk.unreverseMessage' | translate"
  ></div>
  <div *ngIf="actionProps[action] && actionProps[action].confirmMessage" class="gl-popup__checkbox">
    <gl-checkbox
      [id]="'students.edit_anonymize'"
      [label]="'students.bulk.confirmMessage' | translate"
      [checked]="disabledButton"
      [attr.small]="true"
      (onChange)="enabledButton()"
    >
    </gl-checkbox>
  </div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="activateModal.close()"></gl-button>
    <gl-button
      color-primary
      [text]="'actions.confirm' | translate"
      [disabled]="!disabledButton && actionProps[action] && actionProps[action].confirmMessage"
      (onClick)="confirmModal()"
    >
    </gl-button>
  </div>
</lms-modal>

<lms-modal #enrollModal size="medium">
  <div class="gl-popup__title">{{ 'tasks.students.tasks.enroll' | translate }}</div>
  <div class="gl-popup__close" (click)="enrollModal.close()">
    <span class="glicon-close"></span>
  </div>
  <div
    class="gl-popup__text"
    [innerHtml]="'tasks.students.confirmEnrollText' | translate : { studentsCount: this.selectedStudents.length }"
  ></div>
  <div class="gl-popup__text">{{ 'tasks.students.confirmEnrollTagText' | translate }}</div>
  <div class="margin-top">
    <lms-dynamic-form
      [questions]="enrollmentQuestions"
      [options]="{ disableCard: true, isDirtySubmit: true }"
      (submit)="confirmEnrollModal()"
    >
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="enrollModal.close()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
